define('views/modules/calendar/favorite/favorite-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // models
    'models/calendar/favorite',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/favorite/edit/form/favorite-edit-form'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // models
    MFavorite,
    // views
    VModal,
    VFavoriteForm
) {

    var VFavoriteModal = VModal.extend({
        modal: {
            className: 'favorite-modal',
            backdrop: true,
            closeButton: false,
            size: 'small'
        },
        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("Save to my favorites"),
                    callback: this.onConfirm
                },
            });
        },
        initialize: function(opt) {
            this.options = opt = opt || {};

            _.extend(this, { item: opt.item });

            var model = this.model = new MFavorite(),
                view = this.view = {
                    form: new VFavoriteForm({
                        model: model,
                        item: opt.item,
                        create: true
                    }),
                };

            this.listenTo(view.form, { "form:success": this.onSuccess });
        },

        render: function() {
            this.$el.empty()
                .append(this.view.form.render().el);
            return this.renderModal();
        },

        resetModel: function() {
            this.model.reset({ type: this.options.type });
            return this;
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            var form = this.view.form;

            if (confirmed) {
                form.submit();
                return false;
            }

            // default, modal dismissed
            form.setPristine();
            this.disable();
            return;
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

    });

    return VFavoriteModal;

});

